import { render, staticRenderFns } from "./PaginationFirestore.vue?vue&type=template&id=2a9f811e&lang=pug"
import script from "./PaginationFirestore.vue?vue&type=script&lang=js"
export * from "./PaginationFirestore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a9f811e')) {
      api.createRecord('2a9f811e', component.options)
    } else {
      api.reload('2a9f811e', component.options)
    }
    module.hot.accept("./PaginationFirestore.vue?vue&type=template&id=2a9f811e&lang=pug", function () {
      api.rerender('2a9f811e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PaginationFirestore.vue"
export default component.exports